import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';
import { AuthenticationStateService } from 'app/shared/services/state/authentication-state.service';

export const organisationGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);
  const authenticationStateService = inject(AuthenticationStateService);

  if (landingpageConfigurationStateService.hasOrganisation()) {
    return true;
  }

  if (!authenticationStateService.personalAccessToken()) {
    // PersonalAccessTokenGuard is expected to have set this by now, but guards in the same
    // canActivate array run concurrently, not sequentially, so this only holds by array order.
    // Fail closed instead of fetching with a missing token.
    return router.parseUrl('/');
  }

  try {
    await landingpageConfigurationStateService.fetchOrganisation();
    return true;
  } catch {
    sessionStorage.clear();
    return router.parseUrl('/');
  }
};
